import { type CoreCustomer, type ParameterID } from '@flecto/types'

import { api } from '../../../services/api'
import { deserialize } from '../../../services/deserialize'

/**
 * Get a customer details by ID.
 *
 * @endpoint GET /api/saas/me/customers/{customerId}
 * @scope saas
 * @see https://flecto.dev/api-4724210
 */
export async function getCustomerById(
  customerId: ParameterID
): Promise<CoreCustomer> {
  const response = await api.get(`/api/saas/me/customers/${customerId}`)
  const { data } = deserialize<CoreCustomer>(response.data)

  return data
}
